export default __webpack_public_path__ + "static/media/classic.6ff4c150.png";